/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */
export const SliderInputRectifierMixin = (base) =>
  class InputRectifierMixin extends base {
    constructor() {
      super();
      this._stableValue = this._lowStable = this._highStable = 0;
    }

    getLowerValue(value, lowerValue, upperValue, min, max) {
      this._lowStable = lowerValue;
      // If lower input control is empty
      if (value === '') {
        value = this.min;
      } else {
        value = Number(value);
      }
      // Check if the input's value is in allowed range (min <= x <= max)
      if (value >= min && value <= max) {
        // If lower input control is greater than upper value (l > h)
        if (value > upperValue) {
          value = this._lowStable !== undefined ? this._lowStable : min;
        }
      }
      // If lower input control < minimum or > maximum
      if (value < min || value > max) {
        value = this._lowStable !== undefined ? this._lowStable : min;
      }
      // If l <= h and min <= l <= max, then l is stable
      if (value <= upperValue && value >= min && value <= max) {
        this._lowStable = value;
      }
      // If computed number is not a number, then replace with stable values
      value = !Number.isNaN(value) ? this._lowStable : min;
      return value;
    }

    getUpperValue(value, lowerValue, upperValue, min, max) {
      this._highStable = upperValue;
      // If upper input control is empty
      if (value === '') {
        value = max;
      } else {
        value = Number(value);
      }
      // Check if the input's value is in allowed range (min <= x <= max)
      if (value >= min && value <= max) {
        // If upper input control is lesser than lower value (h < l)
        if (value < lowerValue) {
          value = this._highStable !== undefined ? this._highStable : max;
        }
      }
      // If upper input control > maximum or < minimum
      if (value > max || value < min) {
        value = this._highStable !== undefined ? this._highStable : max;
      }
      // If l <= h and min <= h <= max,then h is stable
      if (value >= lowerValue && value >= min && value <= max) {
        this._highStable = value;
      }
      // If computed number is not a number, then replace with stable values
      value = !Number.isNaN(value) ? this._highStable : max;
      return value;
    }

    getValue(value, sliderValue, min, max) {
      this._stableValue = sliderValue;
      // If input control value is empty
      if (value === '') {
        value = this.min;
      } else {
        value = Number(value);
      }
      // If input value is less than minimum or greater than maximum (x < min or x > max)
      if (value < min || value > max) {
        value = this._stableValue !== undefined ? this._stableValue : min;
      }
      // If value is in range, (min <= x <= max), then value is stable
      if (value >= min && value <= max) {
        this._stableValue = value;
      }
      //If value is not a number, then replace input with stable values
      value = !Number.isNaN(value) ? this._stableValue : min;
      return value;
    }
  };
